const styles = {
    sidebar: {
        width: 96,
    },
    paper: {
        backgroundColor: '#F7F8FC',
    },
    text: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '18px',
        color: '#8697AB',
        textAlign: 'center',
    },
    divider: {
        width: '100%',
        color: '#E0E4ED',
    },
    list: {
        marginTop: '16px',
    },
    icon: {
        minWidth: '0',
    },
    active: {
        borderLeft: '5px solid #3D87BF',
    },
};

export default styles;
